const getStoredGroups = (): number[] => {
    const rawGroups = localStorage.getItem('groups');
    if (!rawGroups) {
        return [];
    }
    try {
        const parsed = JSON.parse(rawGroups) as unknown;
        return Array.isArray(parsed) ? parsed.filter((item): item is number => typeof item === 'number') : [];
    } catch {
        return [];
    }
};

export const isSuperUser = (): boolean => localStorage.getItem('is_superadmin') === 'true';

export const getCurrentUserIdFromStorage = (): number | null => {
    const rawUserId = localStorage.getItem('user_id');
    if (!rawUserId) {
        return null;
    }
    const parsed = Number(rawUserId);
    return Number.isNaN(parsed) ? null : parsed;
};

export const isGuestGroupUser = (): boolean => {
    if (isSuperUser()) {
        return false;
    }
    return getStoredGroups().includes(4);
};

export const canCreateBlogPost = (): boolean => !isGuestGroupUser();

export const canEditBlogPost = (authorId: number): boolean => {
    const currentUserId = getCurrentUserIdFromStorage();
    return isSuperUser() || currentUserId === authorId;
};

export const canDeleteBlogComment = (authorId: number): boolean => {
    const currentUserId = getCurrentUserIdFromStorage();
    return isSuperUser() || currentUserId === authorId;
};
